import Vue from 'vue'

const mutations = {
	setLimitStatisticData (state, data) {
		Vue.set(state, 'limitStatisticData', data)
	}
}

export default mutations
